/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLetterFSmall = createReactComponent("letter-f-small", "IconLetterFSmall", [
  ["path", { d: "M10 12h3", key: "svg-0" }],
  ["path", { d: "M14 8h-4v8", key: "svg-1" }]
]);

export { IconLetterFSmall as default };
//# sourceMappingURL=IconLetterFSmall.js.map
